import "./Home.module.css";
import Hero from "./sections/Hero";
import TheUnCookieCutterPhilosophy from "./sections/TheUnCookieCutterPhilosophy";
import YourBespokeLuxuryPath from "./sections/YourBespokeLuxuryPath";
import CuratedTravelModalities from "./sections/CuratedTravelModalities";
import GlobalHiddenGems from "./sections/GlobalHiddenGems";
import BeginYourCuration from "./sections/BeginYourCuration";
import BrandFooter from "@/reusable_sections/Footer";
import WhoWeWorkWith from "./sections/WhoWeWorkWith";
import MeetYourGuide from "./sections/MeetYourGuide";
import TargetAudiences from "./sections/TargetAudiences";
export default function HomePage() {
  return <div>
      <Hero />
      <TheUnCookieCutterPhilosophy />
      <YourBespokeLuxuryPath />
      <TargetAudiences />
      <WhoWeWorkWith />
      <MeetYourGuide />
      <CuratedTravelModalities />
      <GlobalHiddenGems />
      <BeginYourCuration />
      <BrandFooter />
    </div>;
}